import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, withStyles } from 'material-ui';
import { DialogContent, DialogContentText, DialogTitle } from 'material-ui/Dialog';
import CloseIcon from 'material-ui-icons/Close';
import NotificationDialogStyles from './NotificationDialogStyles';
import { CSSTransitionGroup } from 'react-transition-group';

const NotificationDialog = ({ notification, defaultTitle, open, handleClose, classes }) => (
  <CSSTransitionGroup
    transitionName='example'
    transitionAppear
    transitionAppearTimeout={500}
    transitionEnter={false}
    transitionLeave={false}
  >
    <div className='notification'>
      {/* <Collapse
        // id='notification-dialog'
        in={open}
        timeout='auto'
        unmountOnExit
        onClose={handleClose}
        // transition={Transition}
        // transitionDuration={500}
        // classes={classes}
        // // hideBackdrop
        // fullScreen
        // // fullWidth={MainController.showMobileVersion()}
      >
        <div> */}
      <div className='notification-header'>
        <div className='title'>
          <DialogTitle className={`title-${notification.type}`}>
            {notification.title || defaultTitle}
          </DialogTitle>
        </div>
        <div className='close'>
          <IconButton color='inherit' onClick={handleClose} aria-label='Close'>
            <CloseIcon />
          </IconButton>
        </div>
      </div>
      {notification.description ? (
        <DialogContent>
          <DialogContentText>
            {notification.url ? (
              <a href={notification.url}>{notification.description}</a>
            ) : (
              notification.description
            )}
          </DialogContentText>
        </DialogContent>
      ) : null}
    </div>
    {/* </Collapse>
    </div> */}
  </CSSTransitionGroup>
);

NotificationDialog.propTypes = {
  notification: PropTypes.object,
  handleClose: PropTypes.func,
  open: PropTypes.bool,
  defaultTitle: PropTypes.string,
  url: PropTypes.string,
  classes: PropTypes.object,
};

export default withStyles(NotificationDialogStyles)(NotificationDialog);



// WEBPACK FOOTER //
// ./src/components/notifications/NotificationDialog.js